<template>
  <div id="app">
    <div id="nav">
    </div>
    <keep-alive exclude="detail,category"><router-view></router-view></keep-alive>
    <div class="backTop" v-show="isScorll" @click="toTop"><van-icon name="arrow-up" /></div>
  </div>
</template>

<script>

export default {
  name:'',
  data () {
    return {
      isScorll:false
    }
  },
  created(){
    // location.search'http://babyma.top/?code=061QrzE52NBnjP0LBcH52F1DE52QrzEq&state=STATE'
    if(location.pathname === '/authorize'||location.pathname === '/detail'||location.pathname === '/hongbao'){
      return
    }
    
    if(sessionStorage.getItem("userId")&&sessionStorage.getItem("userId")!==''){
      this.$store.dispatch('asyncUpdateUserInfo',{userId:sessionStorage.getItem("userId")}); 
      return
    }
    var url = location.search
    if(url){
      if (url.indexOf("?code") != -1) {
          var str = url.substr(url.indexOf('code=')+5)
          str = str.split("&")
          localStorage.setItem("code", str[0]);
          this.$store.dispatch('asyncGetUserData');
      }
      else{
        window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx338fb1d218a8ec98&redirect_uri=http://babyma.top&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      }
      
    } else{
      window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx338fb1d218a8ec98&redirect_uri=http://babyma.top&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
    }
     
  },
  mounted () {
    window.addEventListener("scroll",this.showbtn,true); 
  },
  methods: {
    showbtn(){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop>2300){
        this.isScorll = true
      }else{
        this.isScorll = false
      }
    },
    toTop(){
      window.scrollTo(0, 0)  
    }
  }
}
</script>

<style lang="less">
@import "./assets/css/base.css";

body{
  background-color: rgb(245, 245, 245);
  box-sizing: border-box;
}
.backTop{
  position: fixed;
  bottom: 7rem;
  right: 1rem;
  width: 4rem;
  height: 4rem;
  background-color: rgba(200, 200, 200, 0.5);
  z-index: 9999999;
  border-radius: 50%;
  color: white;
  font-size: 2rem;
  text-align: center;
  line-height: 4rem;
}
</style>
